import { render, staticRenderFns } from "./BankTransferInformation.vue?vue&type=template&id=6739c3fa&scoped=true&"
import script from "./BankTransferInformation.vue?vue&type=script&lang=js&"
export * from "./BankTransferInformation.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferInformation.vue?vue&type=style&index=0&id=6739c3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6739c3fa",
  null
  
)

export default component.exports